import humanFormat from "human-format";
export const faDigits = txt => {
  let newText = txt;
  for (let i = 0; i < 10; i++)
    newText = (newText + '').replace(
      new RegExp(i + '', 'g'),
      String.fromCharCode((i + '').charCodeAt(0) + (0x06f0 - 0x0030))
    );
  return newText;
}

export const enDigits = txt => {
  let newText = txt;
  for (let i = 0; i < 10; i++)
    newText = (newText + '').replace(
      new RegExp(String.fromCharCode(0x6f0 + i), 'g'),
      i + ''
    );
  return newText;
}

export const leadingZero = num => {
  if (typeof num !== 'number' && !Number.isNaN(num)) {
    throw Error('leadingZeros expects parameter 1 to be number');
  }

  if (num < 0) {
    throw Error('leadingZeros expects parameter 1 to be positive');
  }

  if (num < 10) {
    return `0${num}`;
  }
  return `${num}`;
}

export const humanize = num => faDigits(humanFormat(num));

export const formatDuration = sec => {
  var sec_num = parseInt(sec, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num % 3600) / 60);
  var seconds = sec_num % 60;
  if (hours > 1000) {
    return faDigits(humanFormat(hours));
  }
  return faDigits(`${hours?leadingZero(hours)+':':''}${leadingZero(minutes)}:${leadingZero(seconds)}`)
}